import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type BrandLogoProps = {
  className?: string;
  showLabel?: boolean;
  compact?: boolean;
};

/** Logo de Auto Motopréstamos Oriental Ramírez (logo.png en public). */
export function BrandLogo({ className, showLabel = true, compact = false }: BrandLogoProps) {
  const content = (
    <>
      <img
        src="/logo.png"
        alt="Auto Motopréstamos Oriental Ramírez"
        className={cn("shrink-0 object-contain", compact ? "h-8 w-8" : "h-10 w-10")}
      />
      {showLabel && (
        <span className="flex flex-col leading-tight">
          <span className="font-display font-semibold text-foreground">Oriental Ramírez</span>
          {!compact && <span className="text-[10px] uppercase tracking-wider text-muted-foreground">Admin</span>}
        </span>
      )}
    </>
  );

  return (
    <Link
      to="/"
      className={cn("flex items-center gap-2 no-underline", className)}
      aria-label="Oriental Ramírez - Ir al panel"
    >
      {content}
    </Link>
  );
}
